export default __webpack_public_path__ + "static/media/polaroid4.25174dc7.svg";